import React, { useState } from 'react';
import { Button } from '@material-ui/core';
import {
  FormProvider,
  UseFormHandleSubmit,
  UseFormReturn,
  FieldErrors
} from 'react-hook-form';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { TSelectItem } from '../../types/common';
import { TCloudFileListForm } from '../../types/cloudStorage/CloudFileList';
import { AppDatePicker } from '../parts/input/AppDatePicker';
import { AppSelectfield } from '../parts/input/AppSelectfield';
import { AppTextfield } from '../parts/input/AppTextfield';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

type Tprops = {
  methods: UseFormReturn<TCloudFileListForm, any>;
  selectItem: TSelectItem[];
  handleSubmit: UseFormHandleSubmit<TCloudFileListForm>;
  getSearchedGuestList: () => void;
  errors: FieldErrors<TCloudFileListForm>;
};

/**
 * 検索欄
 * @constructor
 */
export const SearchField: React.FC<Tprops> = (props: Tprops) => {
  const { methods, selectItem, handleSubmit, getSearchedGuestList, errors } =
    props;

  // スタイル読み込み
  const classes = useStyles();

  // 日付validationのための終了日
  const [endDate, setEndDate] = useState('');
  const handleChangeEndDatePicker = (e: any) => {
    setEndDate(e.target.value);
  };

  const onSearch = () => {
    if (!methods.getValues('construct_id')) {
      alert('案件を選択してください');
      return;
    }
    getSearchedGuestList();
  };

  return (
    <FormProvider {...methods}>
      <div className={classes.searchFieldMain}>
        <div style={{ display: 'flex' }}>
          <AppSelectfield
            name='construct_id'
            label='案件'
            listDatas={selectItem}
            style={{ width: 250 }}
          />

          <div className={classes.margin} style={{ width: 150 }}>
            <AppDatePicker
              name='date_from'
              label='開始日'
              toDate={endDate}
              fullWidth={true}
              errorMessage={errors?.date_from?.message}
            />
          </div>
          <div className={classes.margin} style={{ width: 40, margin: 0 }}>
            <span className={classes.textStyle}>〜</span>
          </div>
          <div className={classes.margin} style={{ width: 150 }}>
            <AppDatePicker
              name='date_end'
              label='終了日'
              fullWidth={true}
              onChange={handleChangeEndDatePicker}
            />
          </div>
          <div className={classes.margin} style={{ width: 250 }}>
            <AppTextfield
              name='keyword'
              label='キーワード'
              fullWidth={true}
              maxLength={100}
            />
          </div>
          <div className={classes.margin} style={{ width: 100 }}>
            <Button
              className={classes.searchBtn}
              style={{ margin: '0px 5px' }}
              variant='contained'
              color='primary'
              onClick={handleSubmit(onSearch)}
            >
              検索
            </Button>
          </div>
        </div>
      </div>
    </FormProvider>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    searchFieldMain: {
      backgroundColor: 'white',
      padding: 10
    },
    searchField: {
      borderTop: '1px solid rgb(245, 245, 245)',
      borderBottom: '1px solid rgb(245, 245, 245)',
      padding: 10
    },
    searchBtn: {
      marginBottom: 10,
      marginRight: 20,
      marginLeft: 20,
      backgroundColor: '#52555F'
    },
    center: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    textStyle: {
      margin: '0px 10px',
      fontSize: 18
    },
    margin: {
      margin: '0px 10px'
    }
  })
);

const Heading = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(15),
  fontWeight: theme.typography.fontWeightRegular
}));
